import {getPreferredLanguageFromCookie} from "@/util/locale";

var getConfigurations = () => {
  return require(`./${process.env.VUE_APP_COUNTRY_CODE}.js`)
}

const configs = getConfigurations()

const phone = configs.phone
const email = configs.email
const pdfAgreement = `${process.env.VUE_APP_S3}JForceAgreement.pdf`
const pdfCommissions = `${process.env.VUE_APP_S3}JForceCommissions.pdf`
const pdfFormation = `${process.env.VUE_APP_S3}JForceFormation.pdf`
const pdfFAQ = `${process.env.VUE_APP_S3}JForceFAQ.pdf`
const pdfLevels = `${process.env.VUE_APP_S3}JForceLevels.pdf`
const pdfTraining1 = `${process.env.VUE_APP_S3}JForceTraining1.pdf`
const pdfTraining2 = `${process.env.VUE_APP_S3}JForceTraining2.pdf`
const pdfTraining3 = `${process.env.VUE_APP_S3}JForceTraining3.pdf`

// const defaultLanguage = configurations.defaultLanguage
const supportedLanguages = configs.supportedLanguages
const personalInfo = configs.personalInfo
const paymentMethods = configs.paymentMethods

const lang = getPreferredLanguageFromCookie()
export const rtlSupportedLanguages = ['ar']
const isRTL = rtlSupportedLanguages.includes(lang)

export {
  phone,
  email,
  pdfAgreement,
  pdfCommissions,
  pdfFormation,
  pdfFAQ,
  pdfLevels,
  pdfTraining1,
  pdfTraining2,
  pdfTraining3,
  // defaultLanguage,
  supportedLanguages,
  personalInfo,
  paymentMethods,
  isRTL
}
